import React from 'react';
import PropTypes from 'prop-types';
import FormErrors from "./FormErrors";
import PromoNumberLabel from "./PromoNumberLabel";
import DestinationSelect from "./DestinationSelect";
import CustomDataCheckbox from "./CustomDataCheckbox";

export default class MoveVirtualLineForm extends React.Component {
  render() {
    const promoNumberLabel = <PromoNumberLabel promoNumber={this.props.virtualLineMover.promoNumber} />;
    return (
      <div>
        <FormErrors errors={this.props.virtualLineMover.errors.headerErrors} />
        <form>
          {promoNumberLabel}
          <DestinationSelect
            virtualLineMover={this.props.virtualLineMover}
            updateListener={this.props.updateForm}
          />
          {
            this.props.virtualLineMover.hasCustomData &&
            <CustomDataCheckbox
              moveCustomData={this.props.virtualLineMover.moveCustomData}
              toggleCustomData={this.toggleCustomData.bind(this)}
            />
          }
        </form>
      </div>
    );
  }

  toggleCustomData() {
    this.props.virtualLineMover.moveCustomData = !this.props.virtualLineMover.moveCustomData;
    this.props.updateForm(this.props.virtualLineMover);
  }
}

MoveVirtualLineForm.propTypes = {
  updateForm:             PropTypes.func.isRequired,
  virtualLineMover:       PropTypes.object.isRequired
};
